export default "__VITE_ASSET__a25997a0__"